<div class="grow flex flex-col justify-center">
  <div class="grow flex text-xl font-semibold">
    <ng-content></ng-content>
  </div>
</div>
